import axios from 'axios'
import BigNumber from 'bignumber.js'

import { CONTRACT } from 'constants/contracts'

const GAS_LIMIT = 221000

/** Helper functions for callTransfer */
export function sanitizeHex(hex: string): string {
  hex = hex.substring(0, 2) === '0x' ? hex.substring(2) : hex
  if (hex === '') {
    return ''
  }
  hex = hex.length % 2 !== 0 ? '0' + hex : hex
  return '0x' + hex
}

export function convertStringToHex(value: string | number): string {
  return new BigNumber(`${value}`).toString(16)
}

export function getContract(nftType: string, chainId: number, web3: any) {
  const accessPass = new web3.eth.Contract(CONTRACT[nftType][chainId].abi, CONTRACT[nftType][chainId].address)
  return accessPass
}

export const apiGetGasPrices = async () => {
  let response: any = {}
  try {
    const api_gas = axios.create({
      baseURL: 'https://gpoly.blockscan.com', // old and down: https://gasstation-mainnet.matic.network
      timeout: 10000, // 10 secs
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    response = await api_gas.get('/gasapi.ashx?apikey=key&method=gasoracle')
  } catch (error) {
    console.log('Error on fetching Polygon gas price: ', error)
  }
  return Math.round(response?.data?.result?.SafeGasPrice) || 130
}

export function callTransfer(nftType: string, from: string, to: string, tokenId: number, chainId: number, web3: any) {
  return new Promise(async (resolve, reject) => {
    const accessPass = getContract(nftType, chainId, web3)
    const gasLimit = sanitizeHex(convertStringToHex(GAS_LIMIT * (nftType === 'claws' ? 1.5 : 1)))
    let gasPrice = await apiGetGasPrices()
    console.log('gasPrice from public API:', gasPrice)
    gasPrice = gasPrice * 10 ** 9
    gasPrice = parseInt(sanitizeHex(convertStringToHex(gasPrice)))

    await accessPass.methods
      .transferFrom(from, to, tokenId)
      .send({ from, gasLimit, gasPrice }, (err: any, data: any) => {
        if (err) {
          reject(err)
        }

        resolve(data)
      })
  })
}
